import FormSubmissionOverride from './modules/ajaxFormSubmission';

// FormSubmissionOverride('.filter-form', '.result-container', null, 'load-more');

FormSubmissionOverride('.filter-form', ".result-container", "pag-number");